import { Component, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { PlatformService } from '@panamax/app-state';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';
import { DateService } from '@shared/services/date.service';

@Component({
  selector: 'app-download-import-order-modal',
  templateUrl: './download-import-order-modal.component.html',
  styleUrls: ['./download-import-order-modal.component.scss'],
})
export class DownloadImportOrderModalComponent implements OnInit {
  downloadOrderForm: FormGroup;
  constructor(
    readonly platformService: PlatformService,
    private modalController: ModalController,
    private fb: FormBuilder,
  ) {}

  ngOnInit(): void {
    const fileName = `Invalid_Import_Items_${DateService.formatDateMaintainUTC(
      new Date(),
      '',
    )}`;

    this.downloadOrderForm = this.fb.group({
      fileName: new FormControl(fileName, [Validators.required]),
    });
  }

  async dismissModal(confirmation: boolean) {
    let fileInfo = {
      fileName: '',
      fileType: 'CSV',
    };

    if (confirmation) {
      fileInfo = {
        fileName: this.downloadOrderForm.controls['fileName'].value,
        fileType: fileInfo.fileType,
      };
    }

    await this.modalController.dismiss({
      fileInfo: fileInfo,
      dispatchAction: confirmation,
    });
  }
}
